import * as React from 'react';

function SvgSupplyTeamNotesIcon(props) {
  return (
    <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#supply-team-notes-icon_svg__clip0_1620_26150)">
        <path
          d="M13.714 0H2.285a.57.57 0 00-.571.571V15.43a.57.57 0 00.571.571h11.429a.57.57 0 00.571-.571V.57A.57.57 0 0013.714 0zM9.07 1.286h1.714v3.748l-.83-.605-.884.632V1.286zM13 14.714H3V1.286h5v5.302a.28.28 0 00.053.166.284.284 0 00.398.066l1.497-1.07L11.4 6.81a.287.287 0 00.454-.23V1.286h1.143v13.428H13z"
          fill="#000"
          fillOpacity={0.45}
        />
      </g>
      <defs>
        <clipPath id="supply-team-notes-icon_svg__clip0_1620_26150">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgSupplyTeamNotesIcon;
